import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";
import Swal from "sweetalert2";

function usePrompt(
    when,
    message,
    handleConfirm = undefined
) {
    const { t } = useTranslation()
    const navigator = useContext(NavigationContext).navigator;

    useEffect(() => {
        if(!when) {
            return;
        }

        const push = navigator.push;

        navigator.push = (...args) => {
            Swal.fire({
                title: t('caution'),
                text: message,
                icon: 'warning',
                customClass: 'error',
                showCloseButton: true,
                iconColor: '#FF0000',
                reverseButtons: true,
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: t('confirm'),
                cancelButtonText: t('cancel')
            }).then((result) => {
                if(result.isConfirmed) {
                    if(handleConfirm) {
                        handleConfirm();
                    }
                    setTimeout(() => push(...args), 333)
                }
            })
        };

        return () => {
            navigator.push = push;
        };
    }, [when, message, navigator])
}

export default usePrompt;
